import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/profile')({
  component: () => <Outlet />,
})
